import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Anchor } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { toast } from "sonner";

export default function PartnerLogin() {
  const navigate = useNavigate();
  const { t, lang } = useI18n();
  const [email, setEmail] = useState("demo@charter.com");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      const res = await api.post("/partners/login", { email });
      localStorage.setItem("sm_partner", JSON.stringify(res.data));
      toast.success(lang === "it" ? "Benvenuto!" : "Welcome!");
      navigate("/partners/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="partner-login" className="min-h-screen pt-24 pb-20 bg-sand grain relative overflow-hidden">
      <div className="max-w-md mx-auto px-5 lg:px-0">
        <div className="rounded-2xl bg-white border border-[#E2E8F0] p-8">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-navy">
            <Anchor className="h-4 w-4 text-white" />
          </span>
          <h1 className="mt-5 font-serif text-3xl text-navy tracking-tight">{t("partner.loginTitle")}</h1>
          <p className="mt-2 text-sm text-ink">{t("partner.loginSub")}</p>

          <div className="mt-7">
            <Label className="text-xs uppercase tracking-wider text-ink">Email</Label>
            <Input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 h-12"
            />
          </div>

          <Button
            data-testid="login-submit"
            onClick={submit}
            disabled={loading}
            className="mt-6 w-full bg-navy text-white hover:bg-[#06101f] h-12 rounded-md"
          >
            {loading ? "…" : (lang === "it" ? "Accedi" : "Sign in")}
          </Button>

          <p className="mt-5 text-xs text-ink">
            {lang === "it" ? "Non hai ancora un account?" : "No account yet?"}{" "}
            <button
              data-testid="goto-register"
              onClick={() => navigate("/partners")}
              className="text-navy underline underline-offset-4"
            >
              {lang === "it" ? "Diventa partner" : "Become partner"}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
